(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slideshow-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const buyNowButtons = document.querySelectorAll('.buy-now-button');
  
    buyNowButtons.forEach(button => {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        const productVariantId = this.getAttribute('data-variant-id'); // Ensure this attribute is set correctly in your Liquid template
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: productVariantId,
            quantity: 1
          }),
        })
        .then(response => response.json())
        .then(data => {
          window.location.href = '/cart';
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Scope to this section’s slideshow
    var slideshow = document.querySelector('.product-slideshow');
    if (!slideshow) return;

    // Read slide duration from data attribute instead of using Liquid in JS
    var durationAttr = slideshow.getAttribute('data-slide-duration');
    var slideDuration = Number(durationAttr);
    if (!slideDuration || isNaN(slideDuration)) {
      slideDuration = 5; // Fallback in seconds
    }

    var slides = slideshow.querySelectorAll('.product-slide');
    var totalSlides = slides.length;
    if (!totalSlides) return;

    // Initially hide all slides except the first one
    slides.forEach(function(slide, index) {
      var isFirst = index === 0;
      slide.style.display = isFirst ? 'block' : 'none';
      slide.classList.add(isFirst ? 'active-slide' : 'inactive-slide');
    });

    function goToSlide(index) {
      var currentSlide = slideshow.querySelector('.active-slide');
      if (!currentSlide) return;

      currentSlide.classList.remove('active-slide');
      currentSlide.style.display = 'none';

      slides[index].classList.add('active-slide');
      slides[index].style.display = 'block';
    }

    // Wire up next/prev buttons (first instance inside the slideshow)
    var nextBtn = slideshow.querySelector('.next-slide');
    var prevBtn = slideshow.querySelector('.prev-slide');

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        var currentSlideIndex = Array.from(slides).indexOf(slideshow.querySelector('.active-slide'));
        if (currentSlideIndex === -1) currentSlideIndex = 0;
        var nextSlideIndex = (currentSlideIndex + 1) % totalSlides;
        goToSlide(nextSlideIndex);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        var currentSlideIndex = Array.from(slides).indexOf(slideshow.querySelector('.active-slide'));
        if (currentSlideIndex === -1) currentSlideIndex = 0;
        var prevSlideIndex = (currentSlideIndex - 1 + totalSlides) % totalSlides;
        goToSlide(prevSlideIndex);
      });
    }

    // Auto-advance slides
    function changeSlide() {
      var currentSlide = slideshow.querySelector('.active-slide');
      if (!currentSlide) return;

      currentSlide.classList.remove('active-slide');
      currentSlide.style.display = 'none';

      var nextSlide = currentSlide.nextElementSibling;
      if (!nextSlide || !nextSlide.classList.contains('product-slide')) {
        nextSlide = slides[0];
      }

      nextSlide.classList.add('active-slide');
      nextSlide.style.display = 'block';
    }

    setInterval(changeSlide, slideDuration * 1000);

    // Match section height to background image height (desktop)
    var bgImageSrc = slideshow.style.backgroundImage.replace(/(^url\(")|("\)$)/g, '');
    if (bgImageSrc) {
      var bgImage = new Image();
      bgImage.onload = function() {
        var imageHeight = bgImage.naturalHeight;
        if (imageHeight) {
          slideshow.style.height = imageHeight + 'px';
        }
      };
      bgImage.src = bgImageSrc;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscription-toggle"] && !Shopify.designMode) return;
  try {
    
/* Add JavaScript here */
const productHandles = {
  annual: 'blind-barrels-whiskey-subscription-annual', // Replace with the actual handle of the Annual subscription product
  quarterly: 'quarterly-subscription' // Replace with the actual handle of the Quarterly subscription product
};

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.toggle-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const plan = this.getAttribute('data-plan');
      updateSubscriptionContent(plan);
    });
  });
});

function updateSubscriptionContent(plan) {
  const handle = productHandles[plan];
  if (!handle) {
    console.error('Invalid plan selected or handle not found.');
    return;
  }
  fetch(`/products/${handle}.js`)
  .then(response => response.json())
  .then(product => {
    const productImageSrc = product.images[0]; // Assuming you want the first image
    const productDescription = product.description;

    // Update the image src attribute
    const imageElement = document.getElementById('subscription-product-image');
    if (imageElement) imageElement.src = productImageSrc;

    // Update the product description
    const descriptionElement = document.getElementById('subscription-product-description');
    if (descriptionElement) descriptionElement.innerHTML = productDescription;
  })
  .catch(error => console.error('Error fetching product details:', error));
}

  } catch(e) { console.error(e); }
})();
})();
